import {Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ShareWrapper } from './share-wrapper.component';
import { EntityRequest } from 'globals/store/programs.data';
import { ShareRequestComponent } from './share.request';
import { PublicExhibitorRequestData, PublicStagingRequestData } from 'globals/store/share.data';
import { BrandingData } from 'globals/store/publish.data';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'share-staging-request',
    template: `
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <share-request
    #shareRequest
    [eventTitle]="data?.eventTitle"
    [addeeTitle]="data?.standTitle"
    [adderName]="data?.exhibitorName"
    [request]="data?.request"
    [type]="'exhibitor'"
    [loading]="loading"
    [processing]="processing"
    [submitted]="submitted"
    (submit)="submit($event)"
  ></share-request>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [ShareRequestComponent, BrandingWrapperComponent]
})
export class ShareExhibitorRequestComponent extends ShareWrapper<ShareExhibitorRequestComponent> {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    id:string;
    loading:boolean;
    processing:boolean;
    disabled = true;
    submitted:boolean;
    @ViewChild('shareRequest') shareRequest: ShareRequestComponent
    data: PublicExhibitorRequestData
    brandingData: BrandingData

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      document.title = "loading";
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('id')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.id = params.id;
          const url = `${this.api}/load-exhibitor-request`
          this.take1(this.http.post(url, { id:this.id })).then((data: PublicExhibitorRequestData) => {
            this.data = data
            this.loading = false
            this.brandingData = data.brandingData
            document.title = "Stand request for " + this.data.standTitle;
          }, error => {
            this.loading = false
            document.title = "Unavailable"
          })
        }
      })
    }

    submit(request: EntityRequest) {
      this.processing = true;
      

      request.by = this.data.exhibitorName || this.shareRequest.submitterForAnyone.name || 'anonymous'
      request.type = this.data.exhibitorName ? 'exhibitor' : 'anyone'

      const time = new Date().getTime()
      if (!request.created) request.created = time
      request.modified = time

      const url = `${this.api}/submit-exhibitor-request`
      this.take1(this.http.post(url, {
        id:this.id,
        request
      })).then((data:any) => {
        this.processing = false;
        this.submitted = true;
        if (data.error) {
          this.shareRequest.resultMessage = "File links can't be submitted at this time.\n\nPlease reload this page and try again."
        }
      }, error => {
        console.error({ error })
        this.processing = false;
        this.shareRequest.showError(this.shareRequest.cannotSubmitMessage)
      });
    }
}

